import { SvgIcon } from './svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from './svg-icon.d';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    defaultAriaLabel: 'Mail Icon',
};

export const MailIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props} viewBox="0 0 64 64">
            <g
                fill="#000"
                stroke-linecap="square"
                stroke-linejoin="miter"
                stroke-miterlimit="10"
                transform="translate(0.25 0.25)"
            >
                <polyline
                    fill="none"
                    stroke="#000"
                    stroke-width="1.5"
                    points="12,22 2,27.8 2,62 62,62 62,27.8 52,22"
                    stroke-linecap="butt"
                />
                <polyline
                    fill="none"
                    stroke="#000"
                    stroke-width="1.5"
                    points="12,33.4 12,2 52,2 52,33.2"
                    stroke-linecap="butt"
                />
                <line
                    fill="none"
                    stroke="#000"
                    stroke-width="1.5"
                    x1="2"
                    y1="27.8"
                    x2="62"
                    y2="62"
                    stroke-linecap="butt"
                />
                <line
                    fill="none"
                    stroke="#000"
                    stroke-width="1.5"
                    x1="62"
                    y1="27.8"
                    x2="31.2"
                    y2="44.4"
                    stroke-linecap="butt"
                />
                <line
                    fill="none"
                    stroke="#000"
                    stroke-width="1.5"
                    x1="22"
                    y1="14"
                    x2="42"
                    y2="14"
                />
                <line
                    fill="none"
                    stroke="#000"
                    stroke-width="1.5"
                    x1="22"
                    y1="24"
                    x2="42"
                    y2="24"
                />
            </g>
        </SvgIcon>
    );
};
